import "./PRmanager.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Modal, Button, Table } from "react-bootstrap";
import { useState, useRef, useMemo, useEffect, useCallback } from "react";
import Select from "react-select";
import Stepper from "../StepperComp/stepper";
import PropTypes from "prop-types";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils";
import { useParams, useNavigate } from "react-router-dom";
import useFormValidation from "../../Hooks/useformValidation";
import { submitPrSchema } from "../../Utils/validationSchema";
import useKeyScroll from "../../Hooks/useKeyScroll";
import ReactQuill from "react-quill";
import {
  normalizeHtmlValue,
  getEditorMetrics,
  quillFormats,
  getQuillModules,
  PRContentPreview,
} from "./quillConfig";
import { prepareDescriptionPayload, fixEncodingCorruption } from "../../Utils/encodingUtils";


export default function PRedit({ onShowPRLayout }) {
  const scrollContainerRef = useKeyScroll();
  const { id } = useParams();
  const navigate = useNavigate();

  const [editorData, setEditorData] = useState("");
  const [navshow, setNavshow] = useState(0);
  const [company, setCompany] = useState({
    name: "",
    contactPerson: "",
    address: "",
    mobile: "",
    email: "",
    website: "",
    state: "",
    country: "",
    city: "",
    isdCode: "",
  });
  const [formData, setFormData] = useState({
    packageId: "",
    packageMemberId: "",
    title: "",
    description: "",
    showContactDetails: "YES",
    image: "",
    addNote: "",
    status: "",
    categoryId: "",
  });
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedImagesData, setSelectedImagesData] = useState([]);
  const [limitErrors, setLimitErrors] = useState({});
  const [showSubmit, setShowSubmit] = useState(false);
  const [editorHeight, setEditorHeight] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [companyId, setCompanyId] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [imagesList, setImagesList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [prDetail, setPrDetail] = useState(null);
  const [isDataApplied, setIsDataApplied] = useState(false);

  const fileInputRef = useRef(null);
  const isReadOnly = navshow === 1;

  const WORD_LIMIT = 1500;
  const IMG_LIMIT = 5;
  const LINK_LIMIT = 5;
  const MAX_FILE_SIZE_MB = 10;
  const MAX_FILE_COUNT = 3;
  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "image/bmp",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/csv",
    "application/vnd.ms-excel"
  ];

  const steps = [
    { label: "Edit PR" },
    { label: "Preview & Submit PR" },
    { label: "Submission Successful" },
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    trigger,
    reset,
  } = useFormValidation(submitPrSchema, formData);

  const controlStyles = (hasError) => ({
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: hasError ? "#dc3545 !important" : baseStyles.borderColor,
      boxShadow: hasError && state.isFocused ? "0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important" : baseStyles.boxShadow,
      "&:hover": {
        borderColor: hasError ? "#dc3545 !important" : baseStyles.borderColor,
      },
    }),
    menu: (baseStyles) => ({
      ...baseStyles,
      zIndex: 99,
    }),
    menuPortal: (baseStyles) => ({
      ...baseStyles,
      zIndex: 99,
    }),
  });

  const quillModules = useMemo(() => getQuillModules(Instance), []);

  const resolveCountry = useCallback(
    (countryValue, fallbackIsdCode) => {
      const input =
        countryValue === undefined || countryValue === null
          ? ""
          : String(countryValue).trim();
      const fallback =
        fallbackIsdCode === undefined || fallbackIsdCode === null
          ? ""
          : String(fallbackIsdCode).trim();
      const inputLower = input.toLowerCase();

      let countryMatch =
        countryList.find((c) => String(c.countryCode) === input) ||
        countryList.find(
          (c) => String(c.countryName).trim().toLowerCase() === inputLower,
        ) ||
        countryList.find((c) => String(c.countryId) === input) ||
        null;

      let finalIsdCode = fallback;

      if (fallback) {
        const cleanFallback = fallback.replace("+", "");
        const isdMatch = countryList.find(
          (c) => String(c.isdCode || "").replace("+", "") === cleanFallback
        );
        if (isdMatch) {
          finalIsdCode = String(isdMatch.isdCode);
        }
      } else if (countryMatch && countryMatch.isdCode) {
        finalIsdCode = String(countryMatch.isdCode);
      }

      return {
        country: countryMatch ? String(countryMatch.countryCode) : input,
        isdCode: finalIsdCode,
      };
    },
    [countryList],
  );

  const validateContentLimits = (data) => {
    const wordCount = data
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean).length;
    const imageCount = (data.match(/<img\b[^>]*>/g) || []).length;
    const linkCount = (data.match(/<a\b[^>]*>/g) || []).length;
    const errors = {};
    if (wordCount > WORD_LIMIT)
      errors.wordLimit = `Press Release body must not exceed ${WORD_LIMIT} words.`;
    if (imageCount > IMG_LIMIT)
      errors.imageLimit = `You can add a maximum of ${IMG_LIMIT} images.`;
    if (linkCount > LINK_LIMIT)
      errors.linkLimit = `You can add a maximum of ${LINK_LIMIT} links.`;
    return errors;
  };

  const handleEditorChange = (content) => {
    const validationErrors = validateContentLimits(content);
    setLimitErrors(validationErrors);
    setEditorData(content);
    setValue("editorData", content);
    setValue("description", content);
    if (content && content.trim().length > 0) clearErrors("editorData");
    trigger("editorData");
  };

  const handleEditorResizeStart = (e) => {
    e.preventDefault();
    const startY = e.clientY;
    const startHeight = editorHeight || 300;
    const onMouseMove = (moveEvent) => {
      const delta = moveEvent.clientY - startY;
      setEditorHeight(Math.max(300, startHeight + delta));
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setValue(name, value);
    if (value) clearErrors(name);
  };

  const handleCompanyChange = (e) => {
    let { name, value } = e.target;
    if (name === "contactPerson") {
      value = value.replace(/[^A-Za-z\s]/g, "");
    }
    setCompany({
      ...company,
      [name]: value,
    });
    setValue(name, value);
    trigger(name);
    if ((!!companyId && companyId !== "ADD_NEW") || isReadOnly) {
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyIdChange = (value) => {
    const nextId = value ? String(value) : "";
    if (nextId === "ADD_NEW") {
      setCompanyId("ADD_NEW");
      setValue("company", "ADD_NEW");
      const emptyCompany = {
        name: "",
        contactPerson: "",
        address: "",
        mobile: "",
        email: "",
        website: "",
        state: "",
        country: "",
        city: "",
        isdCode: "",
      };
      setCompany(emptyCompany);
      Object.keys(emptyCompany).forEach((key) => setValue(key, ""));
      return;
    }
    setCompanyId(nextId);
    setValue("company", nextId);

    if (!nextId) {
      const emptyCompany = {
        name: "", contactPerson: "", address: "", mobile: "",
        email: "", website: "", state: "", country: "", city: "", isdCode: "",
      };
      setCompany(emptyCompany);
      Object.keys(emptyCompany).forEach((key) => setValue(key, ""));
      return;
    }

    const selectedCompany = companyList.find(
      (c) => String(c.companyId) === nextId,
    );
    if (!selectedCompany) return;

    const resolved = resolveCountry(
      selectedCompany.country || "",
      selectedCompany.isdCode || "",
    );
    const companyData = {
      name: selectedCompany.name || "",
      contactPerson: selectedCompany.contactPerson || "",
      address: selectedCompany.address || "",
      mobile: selectedCompany.mobile || "",
      email: selectedCompany.email || "",
      website: selectedCompany.website || "",
      state: selectedCompany.state || "",
      country: resolved.country || "",
      city: selectedCompany.city || "",
      isdCode: resolved.isdCode || "",
    };
    setCompany(companyData);
    Object.keys(companyData).forEach((key) => setValue(key, companyData[key]));
    clearErrors(["name", "contactPerson", "email", "mobile", "website", "address", "city", "state", "country"]);
  };

  const handleImageSelectionChange = (selectedOptions) => {
    if (selectedOptions && selectedOptions.length > MAX_FILE_COUNT) {
      showToast(
        `You can only select up to ${MAX_FILE_COUNT} supporting documents.`,
        "danger",
        "error",
      );
      return;
    }
    const selected = (selectedOptions || []).map((opt) => String(opt.value));
    setSelectedImages(selected);
    const imageIdsString = selected.join("|");
    setFormData((prev) => ({ ...prev, image: imageIdsString }));
    setValue("image", imageIdsString);
    trigger("image");

    const selectedData = (selectedOptions || [])
      .map((opt) =>
        imagesList.find((img) => String(img.galleryId) === String(opt.value)),
      )
      .filter(Boolean);
    setSelectedImagesData(selectedData);
  };

  const formatSize = (size) =>
    size > 1024 * 1024
      ? `${(size / (1024 * 1024)).toFixed(2)} MB`
      : `${(size / 1024).toFixed(2)} KB`;

  const handleAddNewClick = (e) => {
    e.preventDefault();
    if (fileInputRef.current) fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const errors = [];
    const validFiles = [];

    if (selectedImages.length + files.length > MAX_FILE_COUNT) {
      errors.push(`You can upload up to ${MAX_FILE_COUNT} supporting documents.`);
    }

    files.forEach((file) => {
      if (!ALLOWED_TYPES.includes(file.type)) {
        errors.push(`${file.name}: Invalid file format. Only JPG, PNG, and PDF are allowed.`);
      } else if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        errors.push(`${file.name}: File size must be ${MAX_FILE_SIZE_MB}MB or less.`);
      } else {
        validFiles.push(file);
      }
    });

    if (errors.length > 0) {
      showToast(errors.join("\n"), "danger", "error");
      event.target.value = null;
      return;
    }

    for (const file of validFiles) {
      const formDataToSubmit = new FormData();
      formDataToSubmit.append("fileUpload", file);
      try {
        const uploadResponse = await Instance.post(
          "site/upload/documents",
          formDataToSubmit,
          { headers: { "content-type": "multipart/form-data" } },
        );
        if (uploadResponse?.data?.resCode === "200") {
          handleUpload(uploadResponse.data.documentUrl, file.name, file.size);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
    event.target.value = null;
  };

  const handleUpload = async (documentUrl, fileName, fileSize) => {
    try {
      const createGalleryResponse = await Instance.post("user/gallery/create", {
        name: fileName,
        documentUrl,
        alternateText: "text",
        docType: "supportingDocument",
        size: fileSize,
      });

      if (createGalleryResponse.data.resCode === "200") {
        showToast("Image Uploaded Successfully", "success", "success");
        const newImage = {
          galleryId: createGalleryResponse.data.id,
          name: fileName,
          documentUrl,
          size: fileSize,
        };

        setImagesList((prev) => [...prev, newImage]);

        setSelectedImages((prevSelected) => {
          const updatedSelected = [...prevSelected, createGalleryResponse.data.id];
          const imageIdsString = updatedSelected.join("|");
          setFormData((prevForm) => ({ ...prevForm, image: imageIdsString }));
          setValue("image", imageIdsString);
          return updatedSelected;
        });

        setSelectedImagesData((prevData) => [...prevData, newImage]);
      } else {
        showToast("Failed to create gallery entry.", "danger", "error");
      }
    } catch (error) {
      console.error("Error creating gallery entry:", error);
      showToast("Error creating gallery entry.", "danger", "error");
    }
  };

  const copyURL = async (url) => {
    const textToCopy = typeof url === "string" ? url : String(url ?? "");
    if (!textToCopy) { showToast("Nothing to copy.", "error", "error"); return; }
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(textToCopy);
        showToast("URL copied!", "success", "success");
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (copied) showToast("URL copied!", "success", "success");
      else showToast("Copy failed. Please copy manually.", "error", "error");
    } catch {
      showToast("Copy failed. Please copy manually.", "error", "error");
    }
  };

  const handleNavShow = () => {
    if (limitErrors && Object.keys(limitErrors).length > 0) {
      showToast(
        "Fix Press release body content errors before proceeding to next step.",
        "error",
        "error",
      );
      return;
    }
    setNavshow(1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNotNavShow = () => setNavshow(0);
  const handleShowSubmit = () => { setShowSubmit(true); setNavshow(2); };
  const handleNotShowSubmit = () => { setShowSubmit(false); setNavshow(1); };
  const handleShowDeleteConfirm = () => setShowDeleteConfirm(true);
  const handleNotShowDeleteConfirm = () => setShowDeleteConfirm(false);

  const handleUpdatePR = async (formValues, status) => {
    if (limitErrors && Object.keys(limitErrors).length > 0) {
      showToast("Fix Press release body content errors before proceeding.", "error", "error");
      return;
    }

    try {
      const {
        name, email, mobile, contactPerson, website,
        address, country, state, city, isdCode,
        editorData,
        packageId,
        ...otherFields
      } = formValues;

      const imageIdsString = selectedImages.join("|");
      const cleanedDescription = prepareDescriptionPayload(formValues.description || "");

      const finalPackageId = packageId || formData.packageId;
      const finalPackageMemberId = formData.packageMemberId ||
        packageList.find(p => String(p.packageId) === String(finalPackageId))?.packageMemberId || "";

      const payload = {
        id,
        ...otherFields,
        title: fixEncodingCorruption(formValues.title || ""),
        packageId: finalPackageId,
        packageMemberId: String(finalPackageMemberId),
        description: cleanedDescription,
        image: imageIdsString,
        showContactDetails: formData.showContactDetails,
        status,
        companyId: companyId === "ADD_NEW" ? "" : (companyId || ""),
        company: (companyId && companyId !== "ADD_NEW")
          ? ""
          : { name, email, mobile, contactPerson, website, address, country, state, city, isdCode },
      };

      const response = await Instance.post("/user/pressrelease/update", payload);

      if (response.data.resCode === "200") {
        showToast(
          `PR ${status === "DRAFT" ? "saved as draft" : "submitted"} successfully`,
          "success",
          "success",
        );
        setShowSubmit(false);
        setTimeout(() => navigate("/customer/pr-manager"), 2000);
      } else {
        showToast(response.data.resMessage, "error", "error");
      }
    } catch (error) {
      // showToast("Failed to update details", "error", "error");
      console.error("Error:", error);
    }
  };

  const fetchCompanies = useCallback(
    (compId) => {
      const payload = compId ? { companyId: compId } : {};
      Instance.post("/user/usercompany/getList", payload)
        .then((response) => {
          if (response.data.resCode === "200") {
            let compData = response.data.message || [];
            if (!Array.isArray(compData)) compData = [compData];
            setCompanyList(compData);
          }
        })
        .catch((error) => console.error("Error fetching company list:", error));
    },
    [],
  );

  const fetchDetails = useCallback(async () => {
    if (!id) return;
    setIsDataApplied(false);
    try {
      const { data } = await Instance.post("/user/pressrelease/details", { id });
      if (data?.resCode === "200") {
        setPrDetail(data.message || null);
        if (data.message?.companyId) fetchCompanies(data.message.companyId);
        else fetchCompanies();
      } else {
        setPrDetail(null);
        fetchCompanies();
      }
    } catch (e) {
      console.error("Failed to fetch PR details:", e);
      setPrDetail(null);
      fetchCompanies();
    }
  }, [id, fetchCompanies]);

  const fetchPackages = useCallback(() => {
    Instance.post("/user/credit/list",
      {
        status: "ACTIVE",
        orderBy: "availablePR",
        orderByType: "DESC",
        availablePR: "1",
      })
      .then((r) => { if (r.data.resCode === "200") setPackageList(r.data.message || []); })
      .catch((e) => console.error("Error fetching package list:", e));
  }, []);

  const fetchCategories = useCallback(() => {
    Instance.post("/user/category/getList", { status: "ACTIVE" })
      .then((r) => { if (r.data.resCode === "200") setCategoryList(r.data.message || []); })
      .catch((e) => console.error("Error fetching category list:", e));
  }, []);

  const fetchGallery = useCallback(() => {
    Instance.post("/user/gallery/getList", { docType: "supportingDocument" })
      .then((r) => { if (r.data.resCode === "200") setImagesList(r.data.message || []); })
      .catch((e) => console.error("Error fetching gallery list:", e));
  }, []);

  const fetchCountryList = useCallback(() => {
    Instance.post("/user/common/countryList", { status: "" })
      .then((r) => {
        if (r.data.resCode === "200") {
          setCountryList(
            (r.data.message || []).filter(
              (c) => String(c.countryName || "").trim() !== "",
            ),
          );
        }
      })
      .catch((e) => console.error("Error fetching countries list:", e));
  }, []);

  useEffect(() => { fetchDetails(); }, [fetchDetails]);

  useEffect(() => {
    fetchPackages();
    fetchCategories();
    fetchGallery();
    fetchCountryList();
  }, [fetchPackages, fetchCategories, fetchGallery, fetchCountryList]);

  useEffect(() => {
    if (!prDetail || isDataApplied) return;

    const needsPackages = prDetail.packageId && packageList.length === 0;
    const needsCompanies = prDetail.companyId && companyList.length === 0;
    const needsCategories = prDetail.categoryId && categoryList.length === 0;
    const needsGallery = prDetail.image && imagesList.length === 0;
    const needsCountries = countryList.length === 0;
    if (needsPackages || needsCompanies || needsCategories || needsGallery || needsCountries) return;

    const item = prDetail;

    // ── Editor ──
    const repairedDescription = fixEncodingCorruption(item.description || "");
    setEditorData(repairedDescription);
    setValue("editorData", repairedDescription);

    // ── Basic fields ──
    const nextFormData = {
      title: item.title || "",
      packageId: item.packageId ? String(item.packageId) : "",
      packageMemberId: item.packageMemberId ? String(item.packageMemberId) : "",
      categoryId: item.categoryId ? String(item.categoryId) : "",
      addNote: item.addNote || "",
      image: item.image || "",
      showContactDetails: item.showContactDetails,
      description: repairedDescription,
      status: item.status || "",
      packageName: item.packageName || "",
    };
    setFormData((prev) => ({ ...prev, ...nextFormData }));

    // Sync react-hook-form values
    Object.entries(nextFormData).forEach(([key, val]) => setValue(key, val));

    // ── Company ──
    const prCompanyId = item.companyId ? String(item.companyId) : "";
    if (prCompanyId) {
      setCompanyId(prCompanyId);
      setValue("company", prCompanyId);

      const validCompany = companyList.find(
        (comp) => String(comp.companyId) === prCompanyId,
      );
      if (validCompany) {
        const resolved = resolveCountry(
          validCompany.country || "",
          validCompany.isdCode || "",
        );
        const companyData = {
          name: validCompany.name || "",
          contactPerson: validCompany.contactPerson || "",
          address: validCompany.address || "",
          mobile: validCompany.mobile || "",
          email: validCompany.email || "",
          website: validCompany.website || "",
          state: validCompany.state || "",
          country: resolved.country || "",
          city: validCompany.city || "",
          isdCode: resolved.isdCode || "",
        };
        setCompany(companyData);
        Object.entries(companyData).forEach(([key, val]) => setValue(key, val));
      }
    } else {
      setCompanyId("");
      setValue("company", "");
      const resolved = resolveCountry(
        item.country || "",
        item.isdCode || item.phoneIsdCode || "",
      );
      const companyData = {
        name: item.companyName || "",
        contactPerson: item.contactPerson || "",
        address: item.companyAddress || "",
        mobile: item.mobile || "",
        email: item.email || "",
        website: item.companyWebsite || "",
        state: item.state || "",
        country: resolved.country || "",
        city: item.city || "",
        isdCode: resolved.isdCode || "",
      };
      setCompany(companyData);
      Object.entries(companyData).forEach(([key, val]) => setValue(key, val));
    }

    // ── Images ──
    const savedIds = item.image
      ? String(item.image).split("|").map((x) => x.trim()).filter(Boolean)
      : [];
    const selectedIds = savedIds.map(String);
    setSelectedImages(selectedIds);

    const matchedImages = imagesList.filter((img) =>
      selectedIds.includes(String(img.galleryId)),
    );
    const missingIds = selectedIds.filter(
      (sid) => !matchedImages.some((img) => String(img.galleryId) === sid),
    );

    let cancelled = false;
    const finalize = (images) => {
      if (cancelled) return;
      setSelectedImagesData(images);
      setIsDataApplied(true);
    };

    if (missingIds.length === 0) {
      finalize(matchedImages);
      return () => { cancelled = true; };
    }

    (async () => {
      try {
        const results = await Promise.all(
          missingIds.map(async (galleryId) => {
            const { data } = await Instance.post("/user/gallery/details", { galleryId });
            return data?.resCode === "200" ? data.message : null;
          }),
        );
        finalize([...matchedImages, ...results.filter(Boolean)]);
      } catch (e) {
        console.error("Failed to fetch gallery details:", e);
        finalize(matchedImages);
      }
    })();

    return () => { cancelled = true; };
  }, [
    prDetail, isDataApplied, packageList, companyList,
    categoryList, imagesList, countryList, resolveCountry, setValue,
  ]);

  const packageOptions = packageList.map((list) => ({
    value: String(list.packageMemberId),
    packageId: String(list.packageId),
    label: `${list.packageName} (Credit Left: ${Number(list.availablePR)} | Expiry: ${list.expiryDate
      ? new Date(list.expiryDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      })
      : ''
      })`,
    isDisabled: Number(list.availablePR) === 0,
  }));

  const categoryOptions = categoryList.map((cat) => ({
    value: String(cat.categoryId),
    label: cat.name || String(cat.categoryId),
  }));
  const companyOptions = companyList.map((comp) => ({
    value: String(comp.companyId),
    label: comp.name || String(comp.companyId),
  }));
  const galleryOptions = imagesList.map((img) => ({
    value: String(img.galleryId),
    label: img.name || String(img.galleryId),
  }));
  const selectedGalleryOptions = galleryOptions.filter((opt) =>
    selectedImages.includes(String(opt.value)),
  );

  const countryOptions = countryList.map((c) => ({
    value: c.countryCode,
    label: c.countryName,
    displayLabel: c.countryName,
    countryCode: c.countryCode,
    isdCode: c.isdCode,
  }));

  const isdOptions = (() => {
    const seen = new Set();
    const opts = [];
    for (const c of countryList) {
      const code = c.isdCode;
      if (!code || seen.has(code)) continue;
      seen.add(code);
      opts.push({
        value: code,
        label: `${c.countryName} ${code}`,
        displayLabel: code,
        countryCode: c.countryCode,
      });
    }
    return opts;
  })();

  return (
    <>
      <div className="pr_preview_container">
        <div className="pr-stepper-container d-flex align-items-center justify-content-between">
          <Stepper currentStep={navshow} steps={steps} />
          <button
            className="back_btn_stepper"
            onClick={() => {
              if (navshow > 0) {
                setNavshow(navshow - 1);
                window.scrollTo({ top: 0, behavior: "smooth" });
              } else {
                onShowPRLayout ? onShowPRLayout() : navigate("/customer/pr-manager");
              }
            }}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Back
          </button>
        </div>

        <div className="pr-form-wrapper bg-white shadow rounded">
          <div className="pr_form_editor">
            <Form className="pr_form_text">

              {/* ── Package & Category ── */}
              <Form.Group className="mb-4">
                <Form.Label>Choose Package</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={packageOptions}
                  value={
                    packageOptions.find((o) => o.value === String(formData.packageMemberId) || (o.packageId === String(formData.packageId) && !formData.packageMemberId)) ||
                    (formData.packageName ? { value: String(formData.packageMemberId), label: formData.packageName } : null)
                  }
                  onChange={(opt) => {
                    const pmId = opt?.value || "";
                    const pId = opt?.packageId || "";
                    setFormData((p) => ({ ...p, packageId: pId, packageMemberId: pmId }));
                    setValue("packageId", pId);
                    setValue("packageMemberId", pmId);
                    trigger("packageId");
                  }}
                  styles={controlStyles(!!errors.packageId)}
                  placeholder="Select from dropdown"
                  isDisabled={isReadOnly || (formData.status && formData.status !== "DRAFT")}
                />
                {errors.packageId && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.packageId?.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Select Categories</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={categoryOptions}
                  value={categoryOptions.find((o) => o.value === String(formData.categoryId)) || null}
                  onChange={(opt) => {
                    const value = opt?.value || "";
                    setFormData((p) => ({ ...p, categoryId: value }));
                    setValue("categoryId", value);
                    trigger("categoryId");
                  }}
                  styles={controlStyles(!!errors.categoryId)}
                  placeholder="Select from dropdown"
                  isDisabled={isReadOnly}
                />
                {errors.categoryId && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.categoryId?.message}
                  </Form.Control.Feedback>
                )}
              </Form.Group>

              {/* ── Headline ── */}
              <Form.Group className="mb-4">
                {navshow !== 1 && (
                  <>
                    <Form.Label>Headline</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter text here"
                      className="submit_form_control"
                      {...register("title")}
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      readOnly={isReadOnly}
                      isInvalid={!!errors.title}
                      onBlur={() => trigger("title")}
                    />
                    {errors.title && (
                      <Form.Control.Feedback type="invalid">
                        {errors.title?.message}
                      </Form.Control.Feedback>
                    )}
                  </>
                )}
              </Form.Group>

              {/* ── Editor / Preview ── */}
              {navshow === 1 ? (
                <PRContentPreview
                  headline={formData.title}
                  bodyHtml={editorData}
                  wordLimit={WORD_LIMIT}
                  imgLimit={IMG_LIMIT}
                  linkLimit={LINK_LIMIT}
                />
              ) : (
                <Form.Group className="mb-4">
                  <Form.Label>Press Release Body</Form.Label>
                  <div
                    className={`custom-ckeditor-wrapper ${editorHeight ? "is-manual-resize" : ""}`}
                    style={{ "--editor-h": editorHeight ? `${editorHeight}px` : "auto" }}
                  >
                    <ReactQuill
                      value={normalizeHtmlValue(editorData)}
                      onChange={handleEditorChange}
                      modules={quillModules}
                      formats={quillFormats}
                      bounds={".custom-ckeditor-wrapper"}
                      placeholder="Start typing your press release here..."
                      readOnly={isReadOnly}
                      theme="snow"
                    />
                    <div
                      className="editor-resize-handle"
                      onMouseDown={handleEditorResizeStart}
                      title="Drag to resize editor"
                    />
                    <div className="editor-footer mt-2">
                      {(() => {
                        const { wordCount, imageCount, linkCount } = getEditorMetrics(editorData);
                        return (
                          <>
                            <span>Word Count: {wordCount}/{WORD_LIMIT}</span>
                            <span>Images: {imageCount}/{IMG_LIMIT}</span>
                            <span>Links: {linkCount}/{LINK_LIMIT}</span>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                  <div className="text-danger mt-2">
                    {limitErrors.wordLimit && <p className="mb-1">{limitErrors.wordLimit}</p>}
                    {limitErrors.imageLimit && <p className="mb-1">{limitErrors.imageLimit}</p>}
                    {limitErrors.linkLimit && <p className="mb-1">{limitErrors.linkLimit}</p>}
                    {errors.editorData?.message && <p>{errors.editorData.message}</p>}
                  </div>
                </Form.Group>
              )}

              {/* ── Supporting Documents ── */}
              <Form.Group className="mb-4">
                <Form.Label>Supporting Documents (Optional)</Form.Label>
                <button
                  className="pr_form_next_btn m-2"
                  onClick={handleAddNewClick}
                  disabled={isReadOnly}
                >
                  Add New
                </button>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  isMulti
                  options={galleryOptions}
                  onChange={handleImageSelectionChange}
                  value={selectedGalleryOptions}
                  isDisabled={isReadOnly}
                  styles={controlStyles(!!errors.image)}
                />
                {errors.image && (
                  <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                    {errors.image?.message}
                  </Form.Control.Feedback>
                )}
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </Form.Group>

              {formData.image && selectedImagesData.length > 0 && (
                <div
                  className="mb-4"
                  style={{ border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}
                >
                  <div
                    style={{ overflowX: "auto", width: "100%", outline: "none" }}
                    ref={scrollContainerRef}
                    tabIndex="0"
                  >
                    <Table
                      className="pr_support_docs_table mb-0"
                      style={{ tableLayout: "fixed", width: "100%", margin: 0 }}
                    >
                      <thead className="pr_tables_head" style={{ backgroundColor: "#f8f9fa" }}>
                        <tr>
                          {["Document Name", "Document URL", "Size", "Copy"].map((h, i) => (
                            <th
                              key={h}
                              style={{
                                width: ["30%", "35%", "15%", "20%"][i],
                                padding: "12px 16px",
                                fontWeight: 600,
                                fontSize: "0.85rem",
                                textTransform: "uppercase",
                                letterSpacing: "0.04em",
                                color: "#495057",
                                borderBottom: "2px solid #dee2e6",
                                textAlign: i === 3 ? "center" : undefined,
                              }}
                            >
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="pr_tables_body">
                        {selectedImagesData.map((detail, index) => (
                          <tr key={index} style={{ borderBottom: "1px solid #dee2e6" }}>
                            <td style={{ padding: "12px 16px", wordBreak: "break-word", overflowWrap: "break-word", verticalAlign: "middle" }}>
                              {detail.name}
                            </td>
                            <td style={{ padding: "12px 16px", wordBreak: "break-word", overflowWrap: "break-word", verticalAlign: "middle", fontSize: "0.82rem", color: "#555" }}>
                              {detail.documentUrl || detail.imgUrl}
                            </td>
                            <td style={{ padding: "12px 16px", verticalAlign: "middle", whiteSpace: "nowrap" }}>
                              {detail.size ? formatSize(detail.size) : "-"}
                            </td>
                            <td style={{ padding: "12px 16px", verticalAlign: "middle", textAlign: "center" }}>
                              <button
                                className="pr_form_next_btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  copyURL("https://pr.webandapi.com" + (detail.documentUrl || detail.imgUrl));
                                }}
                              >
                                Copy
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              )}

              {/* ── Sub-account ── */}
              <Form.Group className="mb-4">
                <Form.Label>Select Sub-account</Form.Label>
                <Select
                  className="submit_form_select"
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  maxMenuHeight={200}
                  menuPlacement="bottom"
                  options={[
                    { value: "ADD_NEW", label: "Add new company" },
                    ...companyList.map((comp) => ({
                      value: String(comp.companyId),
                      label: comp.name || String(comp.companyId),
                    }))
                  ]}
                  value={[
                    { value: "ADD_NEW", label: "Add new company" },
                    ...companyList.map((comp) => ({
                      value: String(comp.companyId),
                      label: comp.name || String(comp.companyId),
                    }))
                  ].find((opt) => opt.value === String(companyId)) || null}
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.value : "";
                    handleCompanyIdChange(value);
                  }}
                  placeholder="Select Company"
                  isDisabled={isReadOnly}
                  styles={controlStyles(false)}
                />
              </Form.Group>

              <h4 className="pr_or">OR</h4>

              {/* ── Company Details ── */}
              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Company Name"
                    className="submit_form_control"
                    {...register("name")}
                    name="name"
                    value={company.name}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.name}
                  />
                  {errors.name && (
                    <Form.Control.Feedback type="invalid">{errors.name.message}</Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Contact Person Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Person Name"
                    className="submit_form_control"
                    {...register("contactPerson")}
                    name="contactPerson"
                    value={company.contactPerson}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.contactPerson}
                  />
                  {errors.contactPerson && (
                    <Form.Control.Feedback type="invalid">{errors.contactPerson.message}</Form.Control.Feedback>
                  )}
                </Col>
              </Row>

              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    placeholder="Enter Email"
                    className="submit_form_control"
                    {...register("email")}
                    name="email"
                    value={company.email}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.email}
                  />
                  {errors.email && (
                    <Form.Control.Feedback type="invalid">{errors.email.message}</Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Phone Number</Form.Label>
                  <div className="phone_input_wrapper">
                    <div className="isd_code_dropdown">
                      <Select
                        options={isdOptions}
                        placeholder="+91"
                        isDisabled={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                        isSearchable
                        classNamePrefix="react-isd-select"
                        menuPortalTarget={document.body}
                        value={isdOptions.find((o) => o.value === company.isdCode) || null}
                        onChange={(val) => {
                          const nextIsd = val?.value || "";
                          const matched = countryList.find(
                            (c) => String(c.isdCode) === String(nextIsd),
                          );
                          setCompany((p) => ({
                            ...p,
                            isdCode: nextIsd,
                            country: matched?.countryCode || p.country,
                          }));
                          setValue("isdCode", nextIsd);
                        }}
                        formatOptionLabel={({ countryCode, displayLabel }) => (
                          <div className="d-flex align-items-center">
                            {countryCode && (
                              <img
                                src={`https://flagcdn.com/w20/${String(countryCode).toLowerCase()}.png`}
                                alt=""
                                className="me-2"
                                style={{ width: "15px", height: "auto" }}
                              />
                            )}
                            <span>{displayLabel}</span>
                          </div>
                        )}
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "8px 0 0 8px",
                            borderColor: "transparent",
                            boxShadow: "none",
                            "&:hover": { borderColor: "transparent" },
                            minHeight: "48px",
                            borderRight: "none",
                          }),
                          menu: (base) => ({ ...base, zIndex: 99, width: "150px" }),
                          menuPortal: (base) => ({ ...base, zIndex: 99 }),
                          menuList: (base) => ({ ...base, maxHeight: "200px" }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected ? "#585edb" : state.isFocused ? "#f1f2fd" : "transparent",
                            color: state.isSelected ? "white" : "#091e42",
                            "&:active": { backgroundColor: "#585edb" },
                          }),
                        }}
                      />
                    </div>
                    <div className="phone_number_input">
                      <Form.Control
                        placeholder="Enter Phone Number"
                        className="submit_form_control"
                        {...register("mobile")}
                        name="mobile"
                        value={company.mobile}
                        onChange={handleCompanyChange}
                        readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                        isInvalid={!!errors.mobile}
                      />
                    </div>
                  </div>
                  {(errors.mobile || errors.isdCode) && (
                    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                      {errors.isdCode?.message || errors.mobile?.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>

              <Row>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Website</Form.Label>
                  <Form.Control
                    placeholder="Enter Website URL"
                    className="submit_form_control"
                    {...register("website")}
                    name="website"
                    value={company.website}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.website}
                  />
                  {errors.website && (
                    <Form.Control.Feedback type="invalid">{errors.website.message}</Form.Control.Feedback>
                  )}
                </Col>
                <Col className="custom_col_submit mb-4">
                  <Form.Label>Company Address</Form.Label>
                  <Form.Control
                    placeholder="Enter Address"
                    className="submit_form_control"
                    {...register("address")}
                    name="address"
                    value={company.address}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.address}
                  />
                  {errors.address && (
                    <Form.Control.Feedback type="invalid">{errors.address.message}</Form.Control.Feedback>
                  )}
                </Col>
              </Row>

              <Row>
                <Col xs="3" className="custom_col_submit mb-4">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    placeholder="Enter City"
                    className="submit_form_control"
                    {...register("city")}
                    name="city"
                    value={company.city}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.city}
                  />
                  {errors.city && (
                    <Form.Control.Feedback type="invalid">{errors.city.message}</Form.Control.Feedback>
                  )}
                </Col>
                <Col xs="3" className="custom_col_submit mb-4">
                  <Form.Label>State</Form.Label>
                  <Form.Control
                    placeholder="Enter State"
                    className="submit_form_control"
                    {...register("state")}
                    name="state"
                    value={company.state}
                    onChange={handleCompanyChange}
                    readOnly={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isInvalid={!!errors.state}
                  />
                  {errors.state && (
                    <Form.Control.Feedback type="invalid">{errors.state.message}</Form.Control.Feedback>
                  )}
                </Col>
                <Col xs="6" className="custom_col_submit mb-4">
                  <Form.Label>Country</Form.Label>
                  <Select
                    className="submit_form_select"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    maxMenuHeight={200}
                    menuPlacement="bottom"
                    options={countryOptions}
                    value={countryOptions.find((o) => o.value === company.country) || null}
                    onChange={(opt) => {
                      const nextCountry = opt?.value || "";
                      setCompany((prev) => ({
                        ...prev,
                        country: nextCountry,
                      }));
                      setValue("country", nextCountry);
                    }}
                    isDisabled={(!!companyId && companyId !== "ADD_NEW") || isReadOnly}
                    isSearchable
                    placeholder="Select Country"
                    styles={controlStyles(!!errors.country)}
                    formatOptionLabel={({ countryCode, label }) => (
                      <div className="d-flex align-items-center">
                        {countryCode && (
                          <img
                            src={`https://flagcdn.com/w20/${String(countryCode).toLowerCase()}.png`}
                            alt=""
                            className="me-2"
                            style={{ width: "20px", height: "auto" }}
                          />
                        )}
                        <span>{label}</span>
                      </div>
                    )}
                  />
                  {errors.country && (
                    <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
                      {errors.country?.message}
                    </Form.Control.Feedback>
                  )}
                </Col>
              </Row>

              {/* ── Note for Editor ── */}
              <Row>
                <Col xs="12">
                  <Form.Group className="mb-4">
                    <Form.Label>Write note for editor?</Form.Label>
                    <Form.Control
                      className="submit_form_select"
                      {...register("addNote")}
                      placeholder="Enter note for editor"
                      name="addNote"
                      value={formData.addNote}
                      onChange={handleChange}
                      disabled={isReadOnly}
                      as="textarea"
                      rows={8}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>

          {/* ── Action Buttons — same handleSubmit pattern as PRpreview ── */}
          <div className="pr_form_btns">
            {navshow === 0 && (
              <>
                {formData.status !== "ACTION REQUIRED" && (
                  <button
                    className="pr_form_save_btn"
                    onClick={handleSubmit(
                      (formValues) => handleUpdatePR(formValues, "DRAFT"),
                      () =>
                        showToast(
                          "Missing Required Fields! Please fill in all mandatory sections (Title and Content).",
                          "error",
                          "error",
                        ),
                    )}
                  >
                    Save as Draft
                  </button>
                )}
                {(formData.status === "ACTION REQUIRED" || formData.status === "DRAFT") && (
                  <button
                    className="pr_form_save_btn ms-2"
                    style={{ backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleShowDeleteConfirm();
                    }}
                  >
                    Delete
                  </button>
                )}
                <button
                  className="pr_form_next_btn ms-2"
                  onClick={handleSubmit(
                    (formValues) => {
                      if (limitErrors && Object.keys(limitErrors).length > 0) {
                        showToast(
                          "Fix Press release body content errors before proceeding to next step.",
                          "error",
                          "error",
                        );
                        return;
                      }
                      setFormData((prev) => ({ ...prev, ...formValues }));
                      setNavshow(1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    },
                    () =>
                      showToast(
                        "Missing Required Fields! Please fill in all mandatory sections (Title and Content).",
                        "error",
                        "error",
                      ),
                  )}
                >
                  Next
                </button>
              </>
            )}
            {navshow === 1 && (
              <>
                {formData.status !== "ACTION REQUIRED" && (
                  <button
                    className="pr_form_save_btn"
                    onClick={handleSubmit(
                      (formValues) => handleUpdatePR(formValues, "DRAFT"),
                      () =>
                        showToast(
                          "Missing Required Fields! Please fill in all mandatory sections.",
                          "error",
                          "error",
                        ),
                    )}
                  >
                    Save as Draft
                  </button>
                )}
                <button className="pr_form_save_btn" onClick={handleNotNavShow}>
                  Edit
                </button>
                {(formData.status === "ACTION REQUIRED" || formData.status === "DRAFT") && (
                  <button
                    className="pr_form_save_btn ms-2"
                    style={{ backgroundColor: "#dc3545", borderColor: "#dc3545", color: "#fff" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleShowDeleteConfirm();
                    }}
                  >
                    Delete
                  </button>
                )}
                <button
                  className="pr_form_submit_btn ms-2"
                  onClick={(e) => {
                    e.preventDefault();
                    handleShowSubmit();
                  }}
                >
                  Submit PR
                </button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* ── Submit Confirmation Modal ── */}
      <Modal show={showSubmit} onHide={handleNotShowSubmit} centered className="custom_modal">
        <Modal.Body>
          <div className="submit_modal_img">
            <img
              className="submit_done_img"
              src="/build/Done.svg"
              alt="zex pr wire Logo"
              width={140}
              height={140}
            />
          </div>
          <div>
            <h5 className="submit_modal_head">Submit PR</h5>
            <p className="submit_modal_content">
              Are you sure you want to submit this Press Release?
            </p>
          </div>
          <div className="pr_modal_btn">
            <Button
              className="submit_cancel_btn"
              variant="secondary"
              onClick={handleNotShowSubmit}
            >
              Cancel
            </Button>
            <Button
              className="submit_save_btn"
              variant="primary"
              onClick={() => {
                const finalStatus = formData.addNote?.trim() ? "PENDING" : "PENDING";
                handleUpdatePR(formData, finalStatus);
              }}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ── Delete Confirmation Modal ── */}
      <Modal show={showDeleteConfirm} onHide={handleNotShowDeleteConfirm} centered className="custom_modal">
        <Modal.Body>
          <div className="">
            <img
              // className="submit_done_img"
              src="/build/imageDelete.svg"
              alt="Delete icon"
              width={60}
              height={60}
            />
          </div>
          <div>
            <h5 className="submit_modal_head">Delete PR</h5>
            <p className="submit_modal_content">
              Are you sure you want to delete this Press Release?
            </p>
          </div>
          <div className="pr_modal_btn">
            <Button
              className="submit_cancel_btn"
              variant="secondary"
              onClick={handleNotShowDeleteConfirm}
            >
              Cancel
            </Button>
            <Button
              className="submit_save_btn"
              variant="danger"
              style={{ backgroundColor: "#dc3545", borderColor: "#dc3545" }}
              onClick={() => {
                handleUpdatePR(formData, "DELETED");
                setShowDeleteConfirm(false);
              }}
            >
              Delete
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

PRedit.propTypes = {
  onShowPRLayout: PropTypes.func,
};
